import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const authServiceWithToken = createApi({
  reducerPath: "authServiceWithToken",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    logout: builder.query<any, any>({
      query: () => ({
        url: `/auth/logout`,
        method: "GET",
      }),
    }),
    sendCodeTwoFa: builder.mutation<any, { mode: number }>({
      query: (body) => ({
        url: `/auth/send-twofa-code`,
        method: "POST",
        body: body,
      }),
    }),
    verifyTwoFaCode: builder.mutation<any, { mode: number; verify_code: string }>({
      query: (body) => ({
        url: `/auth/verify-twofa-code`,
        method: "POST",
        body: body,
      }),
    }),
    setupTwoFaMode: builder.mutation<any, { mode: number }>({
      query: (body) => ({
        url: `/auth/setup-twofa-mode`,
        method: "POST",
        body: body,
      }),
    }),
    createPassword: builder.mutation<any, { password: string }>({
      query: (body) => ({
        url: `/auth/create-password`,
        method: "POST",
        body: body,
      }),
    }),
    checkSetupMode: builder.mutation<any, any>({
      query: (body) => ({
        url: `/auth/check-setup-mode`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
  useLazyLogoutQuery,
  useSendCodeTwoFaMutation,
  useVerifyTwoFaCodeMutation,
  useSetupTwoFaModeMutation,
  useCreatePasswordMutation,
  useCheckSetupModeMutation,
} = authServiceWithToken;
